export const colors = {
  primary: '#288a2a',
  grey: '#f5f5f5',
  secondary: '#7fb78e'
};
